import { inboxConstants } from '@constants/inbox';

const initialState = {
    loading: false,
    data: [],
    conversationId: null,
};

export function inbox(state = initialState, action) {
    switch (action.type) {
        case inboxConstants.INBOX_HISTORY_FETCH:
            return { ...state, loading: true };
        case inboxConstants.INBOX_HISTORY_SUCCESS:
            return { ...state, loading: false, data: action.data, conversationId: action.conversationId };
        case inboxConstants.INBOX_HISTORY_UPDATE:
            return { ...state, data: action.data };
        case inboxConstants.INBOX_MESSAGE_ADD:
            return action.conversationId === state.conversationId
                ? { ...state, data: [...state.data, action.message] }
                : state;
        case inboxConstants.INBOX_RESET:
            return initialState;
        case inboxConstants.INBOX_HISTORY_ERROR:
        default:
            return state;
    }
}
